import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getUserAdmin,
  getUserAdminCompanyProfile,
  getUserAdminDocument,
} from "../../Services/ApiCalling/admin";

export const admin = createAsyncThunk("admin/get", async (token) => {
  try {
    let data = await getUserAdmin(token);
    return { user: data };
  } catch (err) {}
});

export const adminCompanyProfile = createAsyncThunk(
  "admin/adminCompanyProfile",
  async ({ token, id }) => {
    try {
      let data = await getUserAdminCompanyProfile(token, id);
      return { user: data };
    } catch (err) {}
  }
);

export const adminDocument = createAsyncThunk(
  "admin/adminDocument",
  async ({ token, id }) => {
    try {
      let data = await getUserAdminDocument(token, id);
      return { user: data };
    } catch (err) {}
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: null,
    adminCompanyProfile: null,
    adminDocument: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(admin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(admin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload?.user?.data?.data;
      })
      .addCase(admin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch admin data";
      });
    builder
      .addCase(adminCompanyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminCompanyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.adminCompanyProfile = action.payload?.user?.data?.data;
      })
      .addCase(adminCompanyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error?.message || "Failed to fetch company profile";
      });
    builder
      .addCase(adminDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.adminDocument = action.payload?.user?.data?.data;
      })
      .addCase(adminDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to fetch admin document";
      });
  },
});

export default adminSlice.reducer;
